import { useMemo } from 'react';
import useSelector from '@redux/typedHooks';

// Reads the carFilter slice and returns each filter section sorted for stable rendering.
// Brands sort by `value` (its visible label); the rest sort by `name`.
export const useCarFilterOptions = () => {
  const { allFilters, filterNumber, isFetchingFilters } = useSelector((state) => state.carFilter);
  const {
    chassis,
    categories,
    trailerHitch,
    numberOfSeats: numberOfSeatsUnsorted,
    drivetrains: drivetrainsUnsorted,
    brands: brandsUnsorted,
  } = allFilters;

  const numberOfSeats = useMemo(
    () => numberOfSeatsUnsorted?.slice().sort((a, b) => a.name.localeCompare(b.name)) || [],
    [numberOfSeatsUnsorted],
  );

  const drivetrains = useMemo(
    () => drivetrainsUnsorted?.slice().sort((a, b) => a.name.localeCompare(b.name)) || [],
    [drivetrainsUnsorted],
  );

  const brands = useMemo(
    () => brandsUnsorted?.slice().sort((a, b) => a.value.localeCompare(b.value)) || [],
    [brandsUnsorted],
  );

  return {
    allFilters,
    chassis,
    categories,
    trailerHitch,
    numberOfSeats,
    drivetrains,
    brands,
    filterNumber,
    isFetchingFilters,
  };
};
